import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Optional, Output, SimpleChanges } from '@angular/core';
import { GridModalComponent } from '@app/core/components/grid/grid.decorators';
import { Item } from '@app/core/components/listbox/listbox.component';
import { ErrorMessageResponse } from '@app/core/models/data-response';
import { DataTaskService } from '@app/core/services/data-task.service';
import { ModalService } from '@app/core/services/modal.service';
import { StateDialogContext, TT_STATE_DIALOG } from '@app/modal/state-modal/state-modal.component';
import { EconomyService, TaxItem } from '../../../services/economy.service';

@GridModalComponent('projectprocess')
@Component({
    selector: 'tt-project-process',
    templateUrl: './project-process.component.html',
    styleUrls: ['./project-process.component.css'],
})
export class ProjectProcessComponent implements OnInit, OnChanges {
    @Input()
    public params?: GetProjectProcessParams;

    public get?: ProjectProcessGet;

    @Output()
    public submit = new EventEmitter<'save' | 'delete'>();

    public priceMethods: Item[] = [];

    public selectListTaxes: TaxItem[] = [];

    public saving = false;

    public deleting = false;

    constructor(private datatask: DataTaskService, private modal: ModalService, private economy: EconomyService, @Inject(TT_STATE_DIALOG) @Optional() stateDialog?: StateDialogContext) {
        this.initFromDialog(stateDialog);
    }

    public async save() {
        if (!this.get) return;

        try {
            this.saving = true;

            const { errorcode, errormessage } = await this.saveProjectProcess(this.get);

            if ('' + errorcode !== '0') {
                this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: errormessage });
            } else {
                this.submit.emit('save');
            }
        } catch (error) {
            console.error(error);
        } finally {
            this.saving = false;
        }
    }

    public async deleteProcess() {
        if (!this.get) return;

        try {
            this.deleting = true;

            const { errorcode, errormessage } = await this.deleteProjectProcess(this.get);

            if ('' + errorcode !== '0') {
                this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: errormessage });
            } else {
                this.submit.emit('delete');
            }
        } catch (error) {
            console.error(error);
        } finally {
            this.deleting = false;
        }
    }

    private async loadGet() {
        if (!!this.params) {
            this.get = await this.getProjectProcess(this.params);
        }
    }

    private async loadPriceMethods() {
        this.priceMethods = await this.getPriceMethods();
    }

    private async loadTaxes() {
        this.selectListTaxes = await this.economy.getTaxes();
    }

    private async getProjectProcess(params: GetProjectProcessParams): Promise<ProjectProcessGet> {
        return (await this.datatask.Post(908, params))[0];
    }

    private async saveProjectProcess(params: ProjectProcessGet): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(1015, params))[0];
    }

    private async deleteProjectProcess(params: GetProjectProcessParams): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(1016, params))[0];
    }

    private async getPriceMethods() {
        return this.datatask.Post(2203);
    }

    private async init() {
        await this.loadGet();
        this.loadTaxes();
    }

    ngOnInit(): void {
        this.loadPriceMethods();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes['params']) {
            this.init();
        }
    }

    private async initFromDialog(stateDialog?: StateDialogContext) {
        if (!!stateDialog?.params && 'projectprosess_keyno' in stateDialog.params) {
            this.submit.subscribe({ next: (event: any) => stateDialog.close(event) });
            this.params = stateDialog.params as unknown as GetProjectProcessParams;
            stateDialog.setSize({ width: 'min(95vw, 60rem)' });
            await this.init();
            stateDialog.setHeading(this.get?.webpage_heading ?? '');
        }
    }
}

export interface GetProjectProcessParams {
    projectprosess_keyno: string;
    project_keyno: string;
}

export interface ProjectProcessGet {
    project_keyno: `${number}`;
    projectprosess_keyno: `${number}`;
    prosess_id: string;
    prosess_name: string;
    description: string;
    complete_pst: `${number}`;
    timeentry_allowed: string;
    pricemethod_keyno: `${number}`;
    projectprosess_keyno_belongto: `${number}`;
    webpage_heading: string;
    tax_keyno: string;
}
